import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { SlotMachineContext, SocketContext } from "../../../context";
import { ICard } from "../../../interfaces";
import strengthCards from "./strengthCardsData.json";

const useStrengthCardsDemo = () : [ICard[]] => {
    const { randomOneStrengthCardSocketOn, newRandomStrengthCard } = useContext(SocketContext);
    const { lastDroppedCard, allStrengthCardsIdsState, generateFiveNewStrengthCardsManually, addStrengthCardDemo } = useContext(SlotMachineContext);
    const [recievedStrengthCards, setRecievedStrengthCards] = useState<ICard[]>([]);
    const [allStrengthCards] = useState<any>(strengthCards);
    const [currentFiveStrengthCards, setCurrentFiveStrengthCards] = useState<any>([]);
    const isFirstTimeRendering = useRef<boolean>(true);
    const randomNumbersForStrengthCardsId = useRef<any>([]);

    useEffect(() => {

        let isTheSelectedNumberNew : boolean = true;
        let randomNumber: number = 0;

        while(isTheSelectedNumberNew){
            randomNumber = Math.floor(Math.random() * allStrengthCards.length);
            isTheSelectedNumberNew = randomNumbersForStrengthCardsId.current.includes(randomNumber);
        }

        let oldArrayWithOneRefreshedElement = currentFiveStrengthCards.map( (card: any) => {
            if (card?.id === addStrengthCardDemo?.id)
                return allStrengthCards[randomNumber];
           
             return card;           
        })

        setCurrentFiveStrengthCards(oldArrayWithOneRefreshedElement);
    }, [addStrengthCardDemo]);

    useEffect(() =>{
        createStrengthCardListWithICardType(currentFiveStrengthCards);
    }, [currentFiveStrengthCards]);

    useEffect(() => {
        randomOneStrengthCardSocketOn();
    }, [randomOneStrengthCardSocketOn]);

    const createStrengthCardListWithICardType = useCallback((data: any) => {
        let allStrengthCardsIds : any[] = [];
            const recievedCard: any[] = data.map((item: any) => {

                allStrengthCardsIds.push(item?.id || 0);

                return {
                    backImagePath: "",
                    description: item?.description || "",
                    info: item?.information || "x",
                    id: item?.id || 0,
                    type: "StrengthCard"
                }
            });

            allStrengthCardsIdsState.current = allStrengthCardsIds;
            setRecievedStrengthCards(recievedCard);
    }, [allStrengthCardsIdsState])

    const generateRandomUniqueFiveNumbers = () => {
        var fiveRandomUniqueNumbers = [];
        let numberOfStrengthCardsInSlotMachine = 5;

        while(fiveRandomUniqueNumbers.length < numberOfStrengthCardsInSlotMachine){
            var r = Math.floor(Math.random() * allStrengthCards.length);
            if(fiveRandomUniqueNumbers.indexOf(r) === -1) fiveRandomUniqueNumbers.push(r);
        }
        return fiveRandomUniqueNumbers;
    }

    const setNewFiveStrenghtCards = useCallback(() => {
        randomNumbersForStrengthCardsId.current = generateRandomUniqueFiveNumbers();

        const firstIndex : number = randomNumbersForStrengthCardsId.current[0] | 0;
        const secondIndex : number = randomNumbersForStrengthCardsId.current[1] | 0;
        const thirdIndex : number = randomNumbersForStrengthCardsId.current[2] | 0;
        const fourthIndex : number = randomNumbersForStrengthCardsId.current[3] | 0;
        const fifthIndex : number = randomNumbersForStrengthCardsId.current[4] | 0;

        let fiveRandomlyGeneratedUsersFromTheBigArray = [
            allStrengthCards[firstIndex],
            allStrengthCards[secondIndex],
            allStrengthCards[thirdIndex],
            allStrengthCards[fourthIndex],
            allStrengthCards[fifthIndex]
           
        ]
        setCurrentFiveStrengthCards(fiveRandomlyGeneratedUsersFromTheBigArray);
        createStrengthCardListWithICardType(fiveRandomlyGeneratedUsersFromTheBigArray);
    }, [createStrengthCardListWithICardType]);

    useEffect(() => { //when lever is pulled
        setNewFiveStrenghtCards();
    }, [generateFiveNewStrengthCardsManually, setNewFiveStrenghtCards]);

    if (isFirstTimeRendering.current) {  // initial
        setNewFiveStrenghtCards();
        isFirstTimeRendering.current = false;
    }

    useEffect( () => {
        let allStrengthCardsIds : any[] = [];
        
        const newArray = recievedStrengthCards.map( (card: any ) => {          

            if(card.id === lastDroppedCard?.id){
                allStrengthCardsIds.push(lastDroppedCard?.id || 0);
                return {
                    backImagePath: "",
                    description: newRandomStrengthCard?.description,
                    id: newRandomStrengthCard?.id,
                    info: newRandomStrengthCard?.information,
                    type: "StrengthCard"
                }
            }

            allStrengthCardsIds.push(card.id);
            return card;
        });

        allStrengthCardsIdsState.current = allStrengthCardsIds;
        setRecievedStrengthCards(newArray);
    // No cards will be shown in slot machine   
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newRandomStrengthCard]);

    return [recievedStrengthCards];
}

export default useStrengthCardsDemo;